import {fetchGet} from "../libs/reqCommon"
import { Message } from 'element-ui';
import { getFullTime,dateDiff } from '@/libs/date';
console.log(window.location.host)

const state = {
    WS:false,//websocket对象
    WS_url:`wss://${window.location.host}/hcm/websocket/`,//线上正式服务器
    // WS_url:'ws://192.168.1.6:10092/hcm/websocket/',//夏省新本地
    messageJson:{},//当前接收到的消息
    allMsg:[],//聊天记录
    userOpenId:'',//当前聊天用户的openid
    userList:[],//用户列表
    kefuUser:'',
    userData:{
      nickname:'',
      headimgurl:'',
      megid:"",
      noMoremsg:false,
      stateLine:'1',//1离线 0在线
    },
    userInformate:{
      shopList:[]
    },
    username:"",
    keFuList:[],
    ifHavePerson:false,
    logPageNo:1,
    loadBottom:true,//滚动到底部
    sNickName:'',
    lowPriceNoticeList:[[],[],[]]
}
const getters = {

}
const mutations = {
    changeusername(state,params){
      state.username=params
      console.log(state.username)
    },
    changnoMoremsg(state,params){
      state.userData.noMoremsg=params
      console.log(state.userData.noMoremsg)
    },
    clearallMsg(state){
      state.allMsg=[]
    },
    socketstateLine(state,params){
      state.userData.stateLine=params
      sessionStorage.setItem('stateLine',params)
    },
    socketInit(state){
        if (!state.WS) {
          state.WS = new WebSocket(state.WS_url+state.username)
        }
     },
     getServiceMsg(state){
       console.log(state.messageJson)
      if(state.messageJson.openid===state.userOpenId){
        state.allMsg.push(state.messageJson)
        state.loadBottom=true
      }
     },
     socketMessage(state){
        state.WS.onmessage=(event)=>{
          let messageJson = eval("(" + event.data + ")");
          messageJson.type=0//0用户
          state.messageJson=messageJson
          this.commit('getServiceMsg')
          //是否重新请求列表接口
         let clientList=localStorage.getItem('clientList')
         if(clientList){
            if(clientList.split(',').indexOf(messageJson.openid)===-1){
              clientList.split(',').push(messageJson.openid)
            }
            localStorage.setItem('clientList',clientList)
         }else{
            localStorage.setItem('clientList',messageJson.openid)
         }
          this.commit('updateChatList',state.messageJson)
        }
      },
      changeMess(state,messageJson){
        state.messageJson=messageJson
        this.commit('getServiceMsg')
        //是否重新请求列表接口
       let clientList=localStorage.getItem('clientList')
       if(clientList){
          if(clientList.split(',').indexOf(messageJson.openid)===-1){
            clientList.split(',').push(messageJson.openid)
          }
          localStorage.setItem('clientList',clientList)
       }else{
          localStorage.setItem('clientList',messageJson.openid)
       }
        this.commit('updateChatList',state.messageJson)
      },
      //更新列表内容
      updateChatList(state,params){
        let person={}
        state.userList.forEach(item => {
          person[item.openid]=1
          if(item.openid===state.userOpenId){
            item.logList={}
            item.logList.content=params.message//更新当前聊天
          }
          if(params.openid===item.openid){
            //更新列表
            if(item.logList.read==='0')item.unReadCount===1//留言数量
            if(item.openid!==state.userOpenId){
              item.unReadCount=Number(item.unReadCount)//未读
            }
            item.logList={}
            item.logList.content=params.message
            item.logList.createtime=getFullTime()
          }
        });
        if(!person[params.openid])state.ifHavePerson=false//没有当前用户去请求列表
      },
      socketOpen(state,data){
        data.forEach((item)=>{
          if(item.logList){
            if(item.logList.read==='0')item.unReadCount===1//留言数量
          }
          else{
            item.logList=0
          }
        })
        state.userList=data
        state.ifHavePerson=true
        console.log(state.userList)
      },
      socketSend(state,data){
        data.type=1
        state.allMsg.push(data)
      },
      socketClose(state){
        state.WS.close()
        state.WS.onclose = ()=>{
           // 关闭 websocket
           Message.info('离线成功');
           sessionStorage.removeItem("stateLine");
           state.WS=false
           this.commit('socketstateLine','1');
        };
      },
      changeOpenId(state,data){
        state.userOpenId=data.openid
        state.userData.nickname=data.nickname
        state.userData.headimgurl= data.headimgurl
        state.userData.megid=data.megid
      },
      getUserInformate(state,data){
        state.userInformate=data
      },
      clearAllMsg(state){
        state.allMsg=[]
      },
      setKefuList(state,data){
        state.keFuList=data
      },
      getLogList(state,data){
        state.allMsg=data.insert==='start'?[...data.data,...state.allMsg]:[...state.allMsg,...data.data]
      },
      onelogPageNo(state){
        state.logPageNo=1
        state.loadBottom=true
        console.log(state.logPageNo)
      },
      changelogPageNo(state){
        ++state.logPageNo
        state.loadBottom=false
      },
      getServiceName(state,params){
        state.sNickName=params
      },
      changeUserList(state,params){
        state.userList[params.index].unReadCount=params.news
        console.log(state.userList)
      },
      lowPriceList(state,arr){
        //违规通知记录
        var newArr = [];
        let index;
        arr.forEach(function (oldData, i) {
          if(oldData.createtime){
            var alreadyExists = newArr.some(function (newData, j) {
                if (oldData.createtime.substring(0, 16) === newData.createtime.substring(0, 16)) {
                    index = j;
                    return true;
                }
            });
            if (!alreadyExists) {
                newArr.push({
                  createtime: oldData.createtime,
                  res: [oldData]
                });
            } else {
                newArr[index].res.push(oldData);
            }
          }
        });
        let lastArr=[[],[],[]]
        newArr.forEach(item=>{
          if(dateDiff(item.createtime)===0){
            lastArr[0].push(item.res)//今日
          }
          else if(dateDiff(item.createtime)===1){
            lastArr[1].push(item.res)//昨日
          }
          else if(dateDiff(item.createtime)>1){
            lastArr[2].push(item.res)//两天前
          }
        })
        state.lowPriceNoticeList=lastArr
      }
}
const actions = {
    //接收消息
    socketInit({state,commit}){
          return new Promise((r,j)=>{
            commit('socketInit')
            console.log(state.WS)
            state.WS.onerror = function () {
              j()
            }
            let timer = setInterval(()=>{
              //不是正在连接状态
              if(state.WS.readyState!==0){
                clearInterval(timer)
                //正在关闭,关闭
                if([2,3].indexOf(state.WS.readyState) !== -1){
                  state.WS = false
                  j()
                }
                //连接成功
                if(state.WS.readyState===1){
                  r()
                }
              }
            },1000)
          })
        },
      //获取列表
    async socketOpen({state,commit}){
       let res= await fetchGet(`/hcm/weChat/getWechatList`,{servcieName:state.username})
       commit('socketOpen',res.data);
    },
    getFansInfo({state,commit}){
      fetchGet(`/hcm/weChat/getFansInfo`, { openid: state.userOpenId }).then(res => {
        if (res.status === "10000") {
          commit('getUserInformate',res.data);
        }
      });
    },
    //转接客服列表
    getOnlineList({state,commit}){
      fetchGet(`/hcm/websocket/getOnlineList`).then(res => {
        if (res.status === "10000") {
          commit('setKefuList',res.data)
        }
      });
    },
     //聊天记录
    getLogList({state,commit},insert){
      let params={
        openid:state.userOpenId,
        servcieName:state.username,
        pageNo:state.logPageNo,
        pageSize:20
      }
      return new Promise((r,j)=>{
       fetchGet(`/hcm/weChat/getLogList`,params).then((res)=>{
        if (res.status === "10000") {
          res.data.forEach(item => {
            item.message=item.content
            item.picArr=[item.content]
            if(item.messageid==='service'){
              item.type=1//客服
            }else{
              item.type=0//用户
            }
          });
          let obj={
            data:res.data.reverse(),
            insert:insert
          }
          commit('getLogList',obj)
          r(res.data)
        }else{j()}
       }).catch(()=>{
         j()
       })

      })

    },
    //客服昵称
     serviceNickName({state,commit},params){
      return new Promise((r,j)=>{
         fetchGet(`/hcm/weChat/serviceNickName`,{serviceName:params.name}).then((res)=>{
            if(params.type==='sNickName'){
               commit('getServiceName',res.data)
            }
            r(res.data)
         })
      })

    },
    async searchCustomer({state,commit},params){
      let res=await fetchGet(`/hcm/weChat/searchCustomer`,{customerName:params,serviceName:state.username})
      res.data.forEach((item)=>{
        item.logList={}
        item.logList.createtime=item.createtime
        item.logList.content=item.content
      })
      commit('socketOpen',res.data);
    },
    lowpriceNotice({state,commit}){
      fetchGet(`/hcm/lowprice/lowpriceNotice`, {openid: state.userOpenId}).then((res)=>{
        commit('lowPriceList',res.data)
      })
    }
}
export default {
    state,
    getters,
    mutations,
    actions
}
